import { Coordinate } from "PosterEditor/hooks/use-coordinates";
import { getCoordinatesFromGPXString } from "PosterEditor/hooks/use-gpx-parser";

interface GPXFileData {
  name: string | undefined;
  coordinates: Coordinate[];
}

export const loadGPXFromFileInputEvent = async (
  event: React.ChangeEvent<HTMLInputElement>
): Promise<GPXFileData | null> => {
  const file = event.target.files?.[0];
  if (file && file.name.endsWith(".gpx")) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (e) => {
        const text = e.target?.result as string;
        const data = getCoordinatesFromGPXString(text, 1000);
        resolve(data);
      };
      reader.onerror = (error) => {
        reject(error);
      };
      reader.readAsText(file);
    });
  } else {
    alert("Please select a valid GPX file.");
    return null;
  }
};
